module.exports = __webpack_public_path__ + "static/img/icon_worry_free.a23e5df4.svg";